import React from 'react'
import { Plus, Flag, FileText, X } from 'lucide-react';
import { MetricGrid, MetricCard, ActivityChart, C } from './AdminAnalyticsUI';

function AnalyticReportCard({totalCount, xAxisValues, values, rangeLabel}) {
  return (
    <div className='flex flex-col w-full font-plexsans'>
      <MetricGrid cols={4}>
        <MetricCard
          icon={<Plus size={16} strokeWidth={2} color={C.green} />}
          tile="rgba(58,125,79,.1)"
          title="Cases created"
          value={totalCount?.created}
          desc="New cases posted by clients"
        />
        <MetricCard
          icon={<Flag size={16} strokeWidth={2} color={C.brass} />}
          tile="rgba(138,98,49,.1)"
          title="Reports"
          value={totalCount?.reported}
          desc="Total reports submitted"
        />
        <MetricCard
          icon={<FileText size={16} strokeWidth={2} color={C.navy} />}
          tile="rgba(20,33,61,.06)"
          title="Cases reported"
          value={totalCount?.casesReported}
          desc="Distinct cases with at least one report"
        />
        <MetricCard
          icon={<X size={16} strokeWidth={2} color={C.red} />}
          tile="rgba(154,59,46,.08)"
          title="Cases deleted"
          value={totalCount?.deleted}
          desc="Cases removed after more than two reports"
        />
      </MetricGrid>
      <ActivityChart
        xAxisValues={xAxisValues}
        rangeLabel={rangeLabel}
        series={[
          { label: 'Cases created', color: C.green, data: values?.created },
          { label: 'Reports', color: C.red, data: values?.reported },
        ]}
      />
    </div>
  )
}

export default AnalyticReportCard
